import { gql } from '@apollo/client';

export const CORE_INTERVIEW_SECTION_FIELDS = gql`
  fragment CoreInterviewSectionFields on InterviewSection {
    _id
    name
    prompt
    maxQuestions
    duration
    questionType
    createdAt
    updatedAt
    order
    isLast
  }
`;
